import { useSyncExternalStore } from "react";

export type CalendarPageSize = 3 | 5 | 7;

type CalendarDeviceSignals = {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
};

const PHONE_MAX_WIDTH = 640;
const TABLET_MAX_WIDTH = 1180;

export function resolveCalendarPageSize(
  viewportWidth: number,
  device: CalendarDeviceSignals,
): CalendarPageSize {
  if (/\biPhone\b/i.test(device.userAgent)) return 3;
  if (isIPad(device)) return 5;
  if (viewportWidth <= PHONE_MAX_WIDTH) return 3;
  if (viewportWidth <= TABLET_MAX_WIDTH) return 5;
  return 7;
}

export function calendarPageSizeWord(pageSize: CalendarPageSize): "three" | "five" | "seven" {
  if (pageSize === 3) return "three";
  if (pageSize === 5) return "five";
  return "seven";
}

export function useCalendarPageSize(): CalendarPageSize {
  return useSyncExternalStore(subscribeToViewport, currentCalendarPageSize, () => 7);
}

function currentCalendarPageSize(): CalendarPageSize {
  return resolveCalendarPageSize(window.innerWidth, navigator);
}

function subscribeToViewport(onStoreChange: () => void): () => void {
  window.addEventListener("resize", onStoreChange);
  return () => window.removeEventListener("resize", onStoreChange);
}

function isIPad(device: CalendarDeviceSignals): boolean {
  return (
    /\biPad\b/i.test(device.userAgent) ||
    (device.maxTouchPoints > 1 &&
      (device.platform === "MacIntel" || /\bMacintosh\b/i.test(device.userAgent)))
  );
}
